import React, { useState } from "react";
import Card from "../../../Components/CardStucher";
import ParkingDetailsModal from "./ParkingDetailsModal"; // adjust path to match your tree

const BillingDetails = ({ values, setValues, billingRates, desable }) => {
  const {
    RoomBookingCharge = 0,
    parking_price = 0,
    parking_price_total = 0,
    facilityDays = 1,
    service_charge = 0,
    serviceCharge = 0,
    total_tax_rate = 0,
    tax = 0,
    discountAmount = 0,
    total = 0,
    AdvanceAmount = 0,
    PrevBalance = 0,
    RemainingAmount = 0,
    is_prev_apply_balance,
    prev_used_balance,
  } = billingRates || {};

  const [showParkingModal, setShowParkingModal] = useState(false);

  const formatCurrency = (val) => Number(val || 0).toFixed(2);

  const isPreviousCredit = PrevBalance > 0;
  const isPreviousDue = PrevBalance < 0;

  const applyBalance = values.is_apply_balance ?? false;

  const handleApplyBalanceToggle = (e) => {
    const checked = e.target.checked;
    setValues((prev) => ({
      ...prev,
      is_apply_balance: checked,
    }));
  };

  return (
    <Card
      heading={<h6 className="card-title">Billing Details</h6>}
      CardHeaderClass="card-header"
      CardRowClass="row g-3"
    >
      <table className="table table-borderless mb-0">
        <tbody>
          <tr>
            <td className="ps-0">Booking Charge</td>
            <td className="pe-0 text-end">{formatCurrency(RoomBookingCharge)}</td>
          </tr>

          {values.is_parking === "1" && parking_price_total > 0 && (
            <tr>
              <td className="ps-0">
                Car Charges{" "}
                <small
                  className="text-muted"
                  style={{ cursor: "pointer", textDecoration: "underline" }}
                  onClick={() => setShowParkingModal(true)}
                >
                  (view breakdown)
                </small>
              </td>
              <td className="pe-0 text-end">{formatCurrency(parking_price_total)}</td>
            </tr>
          )}

          {serviceCharge > 0 && (
            <tr>
              <td className="ps-0">Service Charge ({service_charge}%)</td>
              <td className="pe-0 text-end">{formatCurrency(serviceCharge)}</td>
            </tr>
          )}

          {billingRates.taxBreakdown?.map((item) => (
            <tr key={item.tax_id}>
              <td className="ps-0">
                {item.tax_name} ({item.rate}%)
              </td>
              <td className="pe-0 text-end">
                {formatCurrency(item.amount)}
              </td>
            </tr>
          ))}

          {discountAmount > 0 && (
            <tr>
              <td className="ps-0">Discount ({values.discount}%)</td>
              <td className="pe-0 text-end">-{formatCurrency(discountAmount)}</td>
            </tr>
          )}

          <tr className="fw-bold border-top">
            <td className="ps-0">Total</td>
            <td className="pe-0 text-end">{formatCurrency(total)}</td>
          </tr>

          {AdvanceAmount > 0 && (
            <tr className="text-success">
              <td className="ps-0">Advance Paid</td>
              <td className="pe-0 text-end">-{formatCurrency(AdvanceAmount)}</td>
            </tr>
          )}
          {(is_prev_apply_balance && prev_used_balance > 0) ? (
            <tr className="text-success">
              <td className="ps-0">Previous Used Credit</td>
              <td className="pe-0 text-end">-{formatCurrency(prev_used_balance)}</td>
            </tr>
          ) : null}

          {PrevBalance !== 0 && (
            <>
              <tr className={isPreviousDue ? "text-danger" : "text-success"}>
                <td className="ps-0">
                  <div className="form-check d-inline-flex align-items-center gap-2 mb-0">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id="is_apply_balance_checkbox"
                      checked={applyBalance}
                      onChange={handleApplyBalanceToggle}
                    />
                    <label className="form-check-label mb-0" htmlFor="is_apply_balance_checkbox">
                      {isPreviousCredit ? "Previous Credit" : "Previous Due"}
                    </label>
                  </div>
                </td>
                <td className="pe-0 text-end">
                  {isPreviousDue ? "" : "-"}
                  {formatCurrency(Math.abs(PrevBalance))}
                </td>
              </tr>

              {!applyBalance && (
                <tr>
                  <td colSpan={2} className="ps-0 pt-0">
                    <small className="text-muted">Not applied to this bill</small>
                  </td>
                </tr>
              )}
            </>
          )}

          <tr className={`fw-bold border-top ${RemainingAmount > 0 ? "text-danger" : "text-success"}`}>
            <td className="ps-0">{RemainingAmount > 0 ? "Due Amount" : "Balance"}</td>
            <td className="pe-0 text-end">{formatCurrency(Math.abs(RemainingAmount))}</td>
          </tr>
        </tbody>
      </table>

      <ParkingDetailsModal
        show={showParkingModal}
        onHide={() => setShowParkingModal(false)}
        movements={values.parking_movements}
        checkin_date={values.checkin_date}
        checkout_date={values.checkout_date}
        parking_price={parking_price}
      />
    </Card>
  );
};

export default BillingDetails;